import { render, staticRenderFns } from "./BriefsTabContentView.vue?vue&type=template&id=635776c0&scoped=true"
import script from "./BriefsTabContentView.vue?vue&type=script&lang=js"
export * from "./BriefsTabContentView.vue?vue&type=script&lang=js"
import style0 from "./BriefsTabContentView.vue?vue&type=style&index=0&id=635776c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635776c0",
  null
  
)

export default component.exports